import { FlowChartNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNode'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'
import { FontSizeType, SizeType } from 'common/builder/nodes/comment/commentNodeConstants'

export enum CommentNodeTextType {
  TEXT = 'text',
  URL = 'url',
}
export interface CommentNodeText {
  type: CommentNodeTextType
  value: string
}

export interface FlowChartCommentNode extends FlowChartNode {
  type: FlowChartNodeType.COMMENT
  data: {
    text: CommentNodeText[]
    fontSize: FontSizeType
    nodeSize: SizeType
  }
}
